import { VStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';

import { useRedeemSummaryContext } from '../../../../contexts/redeem-summary';
import { ExportButton } from '../ExportButton';
import { InfoTooltip } from '../InfoTooltip';
import { StatusSection } from '../StatusSection';

interface SentSummaryProps {}

export const SentSummary: React.FC<SentSummaryProps> = () => {
  const {
    isExportingErrorRegister,
    isExportingSentRegister,
    handleExportErrorRegister,
    handleExportSentRegister,
    redeemDetailsRecords,
  } = useRedeemSummaryContext();
  const Wrapper = useBreakpointValue({
    base: ({ children }) => (
      <VStack
        direction={{ base: 'column', lg: 'row' }}
        space={Spacing['stack.nano']}
        justifyContent="space-between">
        {children}
      </VStack>
    ),
    lg: ({ children }) => children,
  });

  return (
    <Wrapper>
      <StatusSection
        title={<InfoTooltip text="Registros enviados" />}
        status={
          <ExportButton
            isLoading={isExportingSentRegister}
            onPress={handleExportSentRegister}
            count={redeemDetailsRecords?.sent}
          />
        }
      />
      <Box
        borderStyle="dashed"
        borderRightWidth={{ lg: '1px' }}
        borderBottomWidth={{ base: '1px', lg: 0 }}
        borderColor={Color['neutral.light']}
      />
      <StatusSection
        title={<InfoTooltip text="Não enviados" />}
        status={
          <ExportButton
            isLoading={isExportingErrorRegister}
            onPress={handleExportErrorRegister}
            count={redeemDetailsRecords?.error}
          />
        }
      />
    </Wrapper>
  );
};
